import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom-v5-compat';
import i18next from 'src/i18n';
import * as Types from '../../../types';
import { OpenReportingContainer } from '../OpenReportingContainer/OpenReportingContainer';
import { BoldSpan, StyledText, TextWrapper } from './OPRLandingPage.styles';
import OPRLandingPageButtons from './OPRLandingPageButtons';

interface Props {
  descriptionParagraphs: string[];
  descriptionBold?: string;
}

const OPRLandingPage = (props: Props) => {
  const navigate = useNavigate();
  const { slug } = useParams<{ slug: string }>();
  const logo = useSelector(
    (state: Types.State) => state?.openReporting?.openReportReducer?.logo,
  );

  const direction = i18next.dir ? i18next.dir() : 'ltr';

  const onLogin = useCallback(() => {
    navigate('login');
  }, [navigate]);

  if (!slug) return null;

  return (
    <OpenReportingContainer organisation={slug} logo={logo}>
      <TextWrapper direction={direction}>
        <StyledText>
          {props.descriptionParagraphs.map((paragraph, index) => (
            <React.Fragment key={index}>
              {paragraph}
              <br />
              <br />
            </React.Fragment>
          ))}
          {props.descriptionBold && (
            <BoldSpan>{props.descriptionBold}</BoldSpan>
          )}
        </StyledText>
      </TextWrapper>
      <OPRLandingPageButtons
        oprPage="landing"
        handleOnLogin={onLogin}
        organisation={slug}
      />
    </OpenReportingContainer>
  );
};

export default OPRLandingPage;
